import pl from "@locales/auth/pl.json";
import en from "@locales/auth/en.json";

export default {
  pl: pl,
  en: en,
};
